// Manage Users device filter: ?deviceFilter=web|ios|android

import { ALLOWED_RECENT_LIMITS } from './usersRecentLimit';
import { ALLOWED_DEVICE_FILTERS } from '../../../helpers/normalizeSignupDeviceCategory';

export { ALLOWED_DEVICE_FILTERS };

export function parseDeviceFilterFromUrl() {
  const isBrowser = typeof window !== 'undefined';
  if (!isBrowser) {
    return null;
  }
  const params = new URLSearchParams(window.location.search);
  let value = params.get('deviceFilter');
  // Legacy URLs used unknown for web signups.
  if (value === 'unknown') {
    value = 'web';
  }
  if (value && ALLOWED_DEVICE_FILTERS.includes(value)) {
    return value;
  }
  return null;
}

export function buildUsersQueryString({ recentLimit, deviceFilter }) {
  const params = new URLSearchParams();
  if (recentLimit && ALLOWED_RECENT_LIMITS.includes(recentLimit)) {
    params.set('recentLimit', String(recentLimit));
  }
  if (deviceFilter && ALLOWED_DEVICE_FILTERS.includes(deviceFilter)) {
    params.set('deviceFilter', deviceFilter);
  }
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}
